import { ColDef } from "ag-grid-community";

import ScoreCellRenderer from "../cellRenderer/scoreCellRenderer";

export const rankingColumns: ColDef[] = [
  {
    headerName: "Name",
    field: "Name",
    flex: 1,
    resizable: false,
    suppressHeaderMenuButton: true,
  },
  {
    headerName: "Score",
    field: "Score",
    width: 80,
    resizable: false,
    suppressHeaderMenuButton: true,
    cellRenderer: ScoreCellRenderer,
    cellRendererParams: { variant: "chip" },
    headerClass: "centered-header",
    sort: "desc",
  },
];
